'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobxReact = require('mobx-react');

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Table = require('react-bootstrap/lib/Table');

var _Table2 = _interopRequireDefault(_Table);

var _common = require('../common');

var _CaseSearchResultItem = require('./CaseSearchResultItem');

var _CaseSearchResultItem2 = _interopRequireDefault(_CaseSearchResultItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CaseSearchResultsList = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(CaseSearchResultsList, _Component);

  function CaseSearchResultsList() {
    _classCallCheck(this, CaseSearchResultsList);

    return _possibleConstructorReturn(this, (CaseSearchResultsList.__proto__ || Object.getPrototypeOf(CaseSearchResultsList)).apply(this, arguments));
  }

  _createClass(CaseSearchResultsList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          fieldUserSearchedBy = _props.fieldUserSearchedBy,
          hasMoreResults = _props.hasMoreResults,
          isLoading = _props.isLoading,
          items = _props.items,
          onItemClick = _props.onItemClick,
          onLoadMoreClick = _props.onLoadMoreClick,
          isLoadingMore = isLoading && items.length > 0,
          MEDICAL_FILTER_FIELDS = ['facility', 'facility_contact', 'provider'],
          isMedical = MEDICAL_FILTER_FIELDS.includes(fieldUserSearchedBy),
          showLawFirmColumn = fieldUserSearchedBy !== 'lawfirm';


      return _react2.default.createElement(
        _Table2.default,
        { responsive: true },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'th',
              { className: 'col-lg-1 col-md-1 col-sm-1' },
              'Plaintiff'
            ),
            _react2.default.createElement(
              'th',
              { className: 'col-lg-2 col-md-2 col-sm-2' },
              showLawFirmColumn ? 'Law Firm' : 'Attorney'
            ),
            _react2.default.createElement(
              'th',
              { className: 'col-lg-1 col-md-1 col-sm-1' },
              'Status'
            ),
            _react2.default.createElement(
              'th',
              { className: 'col-lg-2 col-md-2 col-sm-2' },
              'Total ',
              isMedical ? 'Billing' : 'Principal'
            ),
            _react2.default.createElement(
              'th',
              { className: 'col-lg-2 col-md-2 col-sm-2' },
              'Total Returned'
            ),
            _react2.default.createElement(
              'th',
              { className: 'head-last-activity col-lg-4 col-md-4 col-sm-4' },
              'Last Activity'
            )
          )
        ),
        _react2.default.createElement(
          'tbody',
          null,
          items.map(function (item) {
            return _react2.default.createElement(_CaseSearchResultItem2.default, {
              key: item.id,
              item: item,
              onItemClick: onItemClick,
              fieldUserSearchedBy: fieldUserSearchedBy
            });
          })
        ),
        _react2.default.createElement(
          'tfoot',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              { className: 'text-center', colSpan: '6' },
              hasMoreResults && _react2.default.createElement(
                _Button2.default,
                { disabled: isLoadingMore, onClick: onLoadMoreClick },
                isLoadingMore ? _react2.default.createElement(_common.Loader, { className: 'button-loader' }) : 'Load More'
              )
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return CaseSearchResultsList;
}(_react.Component), _class2.propTypes = {
  fieldUserSearchedBy: _propTypes2.default.string,
  hasMoreResults: _propTypes2.default.bool,
  isLoading: _propTypes2.default.bool,
  items: _propTypes2.default.arrayOf(_propTypes2.default.object),
  onItemClick: _propTypes2.default.func.isRequired,
  onLoadMoreClick: _propTypes2.default.func.isRequired
}, _temp)) || _class) || _class;

var _default = CaseSearchResultsList;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CaseSearchResultsList, 'CaseSearchResultsList', '/app/src/components/page-case-search-results/CaseSearchResultsList.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case-search-results/CaseSearchResultsList.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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